import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const painPoints = [{
  emoji: '😰',
  text: 'Publicás contenido, pero no vendés'
}, {
  emoji: '👀',
  text: 'Tenés vistas, pero nadie compra'
}, {
  emoji: '📉',
  text: 'Tus anuncios no convierten'
}, {
  emoji: '⏰',
  text: 'Perdés horas pensando qué publicar'
}, {
  emoji: '🤯',
  text: 'No sabés qué decir para generar deseo'
}, {
  emoji: '📲',
  text: 'Tus reels entretienen, pero no traen clientes'
}, {
  emoji: '💬',
  text: 'No sabés cómo cerrar con un buen CTA'
}, {
  emoji: '🤖',
  text: 'Usás IA, pero los resultados salen genéricos'
}, {
  emoji: '🔥',
  text: 'Sentís que tu contenido se ve bien, pero no genera ventas'
}];
export const PainPoints = () => {
  return <section className="py-12 md:py-24 bg-brand-card/30" data-id="element-102">
      <div className="container px-4 mx-auto max-w-5xl" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10 md:mb-16 text-center" data-id="element-104">
          <h2 className="mb-3 md:mb-4 text-3xl font-bold md:text-5xl" data-id="element-105">
            Esto es para vos si...
          </h2>
          <p className="text-base md:text-xl text-gray-400" data-id="element-106">
            ¿Te sentís identificado con alguna de estas situaciones?
          </p>
        </motion.div>

        <div className="grid gap-3 md:gap-4 md:grid-cols-2 lg:grid-cols-3 mb-8 md:mb-12" data-id="element-107">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3 md:gap-4 p-4 md:p-6 border rounded-xl bg-brand-dark border-white/5" data-id="element-108">
              <span className="text-2xl shrink-0" data-id="element-109">{point.emoji}</span>
              <p className="text-gray-300" data-id="element-110">{point.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex items-center justify-center gap-3 p-4 md:p-6 text-base md:text-lg font-medium text-center border rounded-xl bg-brand-gold/10 border-brand-gold/20 text-brand-gold-light" data-id="element-111">
          <CheckCircle2 className="w-6 h-6 shrink-0" data-id="element-112" />
          <p data-id="element-113">
            Si te identificás con al menos una, Marketing PRO fue diseñado para
            vos.
          </p>
        </motion.div>
      </div>
    </section>;
};